export default __webpack_public_path__ + "847af73cbd6bdb859ff12b1f01172507.svg";